<template>
  <section>
    <div class="d-flex align-items-center justify-content-between mb-2">
      <div class="d-flex align-items-center">
        <h1 class="title mr-3">{{ $t('entity.docs') }}</h1>
      </div>
    </div>

    <div id="container" class="card-list-container">
      <div class="card simple-card d-flex">
        {{ $t('documents.memo') }}
        <a href="/files/memo-09.09.20.pdf" download
          ><button type="button" class="btn btn-primary mt-2">
            {{ $t('button.download') }}
          </button></a
        >
      </div>
      <div class="card simple-card d-flex">
        {{ $t('documents.instruction') }}
        <a href="/files/instruction-12.01.20.pdf" download
          ><button type="button" class="btn btn-primary mt-2">
            {{ $t('button.download') }}
          </button></a
        >
      </div>
      <div class="card simple-card d-flex">
        {{ $t('documents.app') }}
        <div class="mt-2">
          <svg-icon
            class="svg-icon mr-1"
            :name="googleIconName"
            :isDisabled="false"
            :width="150"
            :height="50"
            @click:icon="openGooglePlay"
          ></svg-icon>
          <svg-icon
            v-if="localeRU"
            class="svg-icon"
            :name="'rustore-ru'"
            :isDisabled="false"
            :width="150"
            :height="50"
            @click:icon="openRustore"
          ></svg-icon>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import SvgIcon from '@/components/SvgIcon.vue'
export default {
  name: 'DocumentsPage',
  components: {
    SvgIcon
  },
  data: () => ({}),
  computed: {
    localeRU() {
      if (this.$i18n.locale === 'ru') {
        return true
      } else return false
    },
    googleIconName() {
      return this.localeRU ? 'googleplay-ru' : 'googleplay-en'
    }
  },
  methods: {
    openGooglePlay() {
      window.open('https://play.google.com/store/apps/details?id=com.neurosoft.ecgsmarttrainer', '_blank')
    },
    openRustore() {
      window.open('https://www.rustore.ru/catalog/app/com.neurosoft.ecgsmarttrainer', '_blank')
    }
  }
}
</script>
